import React from "react";

const VectorHotAirBalloon = ({ variant = 1, ...props }) => {
    
    // Solid Colors - High Contrast
    const primaryColor = variant === 1 ? "#f3b19dff" : "#dabbe7ff"; // Vivid Red / Deep Purple
    const secondaryColor = variant === 1 ? "#fdf29dff" :"rgba(197, 238, 218, 1)"; // Vivid Yellow / Bright Green
    const strokeColor = "#664640b9"; // Dark Brown outline

    return (
        <svg
            width="60"
            height="80"
            viewBox="0 0 60 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Balloon Body - Bulbous Shape */}
            <path
                d="M30 0 C13.4315 0 0 13.4315 0 30 C0 45 12 55 24 60 L26 62 H34 L36 60 C48 55 60 45 60 30 C60 13.4315 46.5685 0 30 0 Z"
                fill={primaryColor}
                stroke={strokeColor}
                strokeWidth="1"
            />
            
            {/* Vertical Stripes (Overlay) */}
             <path
                 d="M30 0 C22 0 16 15 16 30 C16 42 22 55 26 62 H34 C38 55 44 42 44 30 C44 15 38 0 30 0 Z"
                 fill={secondaryColor}
                 stroke={strokeColor}
                 strokeWidth="2"
             />

             {/* Center Stripe */}
             <path
                 d="M30 0 C28 0 28 30 28 30 V62 H32 V30 C32 30 32 0 30 0 Z"
                 fill={primaryColor}
                 // No stroke here to blend or maybe just center line
             />
             
             {/* Simple center line for detail */}
             <path d="M30 0 V62" stroke={strokeColor} strokeWidth="1.5" />


            {/* Ropes */}
            <line x1="24" y1="62" x2="24" y2="70" stroke={strokeColor} strokeWidth="1.5" />
            <line x1="36" y1="62" x2="36" y2="70" stroke={strokeColor} strokeWidth="1.5" />
            
            {/* Basket */}
            <rect x="22" y="70" width="16" height="10" rx="2" fill="#795548" stroke={strokeColor} strokeWidth="2" />
             
        </svg>
    );
};

export default VectorHotAirBalloon;
